import type { IconProps } from './icons.types';

export function DotIcon({ size = 4 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 4 4" fill="currentColor" aria-hidden="true">
      <circle cx="2" cy="2" r="2" />
    </svg>
  );
}
